let interactionHappened = false;

function initImmediate() {
  initLazySections();
  setupInteractionListeners();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImmediate);
} else {
  initImmediate();
}

function setupInteractionListeners() {
  const events = ['scroll', 'mousedown', 'keydown', 'touchstart', 'wheel'];
  const onInteraction = async () => {
    if (interactionHappened) return;
    interactionHappened = true;
    
    events.forEach(evt => window.removeEventListener(evt, onInteraction));
    
    // Lightweight components
    initWishlist();
    initComparison();
    initB2BFormTabs();
    
    // GSAP, ScrollTrigger, Lenis dynamic load on desktop/tablet
    const isMobile = window.innerWidth < 768;
    if (!isMobile) {
      try {
        await loadAnimationLibraries();
        initScrollReveal();
      } catch (err) {
        console.warn('[KSA] Failed to load animation libraries, falling back:', err);
        forceFallbackReveal();
      }
    } else {
      forceFallbackReveal();
    }
  };
  
  events.forEach(evt => window.addEventListener(evt, onInteraction, { passive: true }));
}

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

let scriptsLoaded = false;
async function loadAnimationLibraries() {
  if (scriptsLoaded) return;
  await loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js');
  await loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js');
  await loadScript('https://unpkg.com/lenis@1.1.13/dist/lenis.min.js');
  scriptsLoaded = true;
}

/* ─── Viewport Lazy Section Loader ────────────────────────────── */
function initLazySections() {
  const sections = document.querySelectorAll('.lazy-load-section');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(unpackSection);
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        unpackSection(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '250px 0px',
    threshold: 0.01
  });

  sections.forEach(sec => observer.observe(sec));
}

function unpackSection(section) {
  const template = section.querySelector('.lazy-load-template');
  if (!template) return;
  const content = template.content.cloneNode(true);
  
  const scripts = Array.from(content.querySelectorAll('script'));
  
  section.appendChild(content);
  template.remove();

  scripts.forEach(oldScript => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });

  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }

  if (section.querySelector('.testimonials-slides-row')) {
    initCSSMarquee();
  }
  if (section.querySelector('.stat-number')) {
    initStatsCounters();
  }

  if (window.innerWidth < 768 || typeof gsap === 'undefined') {
    forceFallbackReveal();
  }
}

/* ─── B2B Tab Switching Logic ─────────────────────────────────── */
function initB2BFormTabs() {
  const tabs = document.querySelectorAll('.b2b-tab');
  const forms = document.querySelectorAll('.b2b-form-content');
  if (!tabs.length || !forms.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetFormId = tab.getAttribute('data-tab');
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      forms.forEach(form => {
        form.classList.remove('active');
        if (form.id === targetFormId) form.classList.add('active');
      });
    });
  });

  const b2bForms = document.querySelectorAll('.b2b-form');
  b2bForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'TRANSMITTING ENCRYPTED REQUEST...';
      setTimeout(() => {
        submitBtn.innerHTML = 'REQUEST SENT SECURELY ✓';
        submitBtn.style.backgroundColor = '#00ff66';
        submitBtn.style.color = '#000000';
        const alertDiv = document.createElement('div');
        alertDiv.className = 'tactical-badge';
        alertDiv.style.cssText = 'display:block;margin-top:20px;padding:12px;text-align:center;width:100%';
        alertDiv.innerText = 'SECURE PROCUREMENT REQUEST RECEIVED. A GOVERNMENT & DEFENSE REPRESENTATIVE WILL CONTACT YOU WITHIN 2 HOURS.';
        form.appendChild(alertDiv);
        form.reset();
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.backgroundColor = '';
          submitBtn.style.color = '';
          alertDiv.remove();
        }, 5000);
      }, 1500);
    });
  });
}

/* ─── Wishlist (localStorage) ─────────────────────────────────── */
function initWishlist() {
  updateWishlistUI();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-toggle-btn');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    const title  = btn.getAttribute('data-product-title') || handle;
    const price  = btn.getAttribute('data-product-price') || '';
    const image  = btn.getAttribute('data-product-image') || '';
    const url    = btn.getAttribute('data-product-url') || '';
    if (!handle) return;
    let wishlist = getWishlist();
    const index = wishlist.findIndex(item => item.handle === handle);
    if (index === -1) {
      wishlist.push({ handle, title, price, image, url });
      btn.classList.add('in-wishlist');
      btn.innerHTML = 'REMOVE FROM WISHLIST';
      showToast(`ADD: ${title.toUpperCase()} SECURED IN WISHLIST.`);
    } else {
      wishlist.splice(index, 1);
      btn.classList.remove('in-wishlist');
      btn.innerHTML = 'ADD TO WISHLIST';
      showToast(`REMOVE: ${title.toUpperCase()} DELETED FROM WISHLIST.`);
    }
    saveWishlist(wishlist);
    updateWishlistUI();
  });
}

function getWishlist() {
  try { return JSON.parse(localStorage.getItem('ksa_armor_wishlist')) || []; }
  catch (e) { return []; }
}
function saveWishlist(wishlist) {
  localStorage.setItem('ksa_armor_wishlist', JSON.stringify(wishlist));
}
function updateWishlistUI() {
  const wishlist = getWishlist();
  const headerBadge = document.getElementById('header-wishlist-count');
  if (headerBadge) {
    if (wishlist.length > 0) {
      headerBadge.innerText = wishlist.length;
      headerBadge.style.display = 'inline-block';
    } else {
      headerBadge.style.display = 'none';
    }
  }
  document.querySelectorAll('.wishlist-toggle-btn').forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    if (wishlist.some(item => item.handle === handle)) {
      btn.classList.add('in-wishlist');
      btn.innerHTML = 'REMOVE FROM WISHLIST';
    } else {
      btn.classList.remove('in-wishlist');
      btn.innerHTML = 'ADD TO WISHLIST';
    }
  });
  const wishlistContainer = document.getElementById('tactical-wishlist-container');
  if (!wishlistContainer) return;
  if (wishlist.length === 0) {
    wishlistContainer.innerHTML = `
      <div style="text-align:center;padding:50px 0;border:1px dashed var(--color-border)">
        <p class="tactical-mono" style="color:var(--color-foreground-muted)">WISHLIST DIRECTORY IS EMPTY. NO PRODUCTS REGISTERED.</p>
        <a href="/collections/all" class="button" style="margin-top:15px">EXPLORE GEAR</a>
      </div>`;
  } else {
    wishlistContainer.innerHTML = wishlist.map(item => `
      <div class="product-card" style="display:flex;gap:15px;margin-bottom:15px;align-items:center">
        <img src="${item.image}" alt="${item.title}" style="width:80px;height:80px;object-fit:cover;border:1px solid var(--color-border)" loading="lazy" />
        <div style="flex:1">
          <h4 style="margin:5px 0 0"><a href="${item.url}" style="color:var(--color-foreground-heading);text-decoration:none">${item.title}</a></h4>
          <p class="tactical-mono" style="margin:5px 0 0;color:var(--color-accent-tactical)">${item.price}</p>
        </div>
        <div>
          <a href="${item.url}" class="button" style="padding:8px 16px;font-size:0.75rem">VIEW GEAR</a>
          <button class="wishlist-toggle-btn button" data-product-handle="${item.handle}" data-product-title="${item.title}" style="padding:8px 16px;font-size:0.75rem;background:transparent;border-color:red!important;color:red">DELETE</button>
        </div>
      </div>`).join('');
  }
}

/* ─── Product Comparison ──────────────────────────────────────── */
function initComparison() {
  createCompareFloatingBtn();
  updateCompareUI();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.compare-toggle-btn');
    if (!btn) return;
    e.preventDefault();
    const handle    = btn.getAttribute('data-product-handle');
    const title     = btn.getAttribute('data-product-title') || handle;
    const image     = btn.getAttribute('data-product-image') || '';
    const level     = btn.getAttribute('data-product-level') || 'NIJ Level IIIA';
    const weight    = btn.getAttribute('data-product-weight') || '1.4 kg';
    const thickness = btn.getAttribute('data-product-thickness') || '6 mm';
    const material  = btn.getAttribute('data-product-material') || 'PE/Alumina';
    if (!handle) return;
    let list = getCompareList();
    const index = list.findIndex(item => item.handle === handle);
    if (index === -1) {
      if (list.length >= 4) { showToast('COMPARE DIRECTORY FULL. MAXIMUM 4 ITEMS ALLOWED.'); return; }
      list.push({ handle, title, image, level, weight, thickness, material });
      btn.classList.add('in-compare');
      btn.innerHTML = 'REMOVE FROM COMPARE';
      showToast(`ADD: ${title.toUpperCase()} REGISTERED FOR SPECS CHECK.`);
    } else {
      list.splice(index, 1);
      btn.classList.remove('in-compare');
      btn.innerHTML = 'ADD TO COMPARE';
      showToast(`REMOVE: ${title.toUpperCase()} DELETED FROM SPECS CHECK.`);
    }
    saveCompareList(list);
    updateCompareUI();
  });
  const floatingBtn = document.getElementById('floating-compare-trigger');
  if (floatingBtn) floatingBtn.addEventListener('click', () => toggleCompareModal(true));
}

function getCompareList() {
  try { return JSON.parse(localStorage.getItem('ksa_armor_compare')) || []; }
  catch (e) { return []; }
}
function saveCompareList(list) { localStorage.setItem('ksa_armor_compare', JSON.stringify(list)); }

function createCompareFloatingBtn() {
  if (document.getElementById('floating-compare-trigger')) return;
  const btn = document.createElement('div');
  btn.id = 'floating-compare-trigger';
  btn.className = 'compare-badge-trigger';
  btn.innerHTML = 'SPECS COMPARISON <span id="compare-count-badge">0</span>';
  document.body.appendChild(btn);
  const modal = document.createElement('div');
  modal.id = 'tactical-compare-drawer';
  modal.className = 'tactical-drawer';
  modal.innerHTML = `
    <div class="tactical-drawer__header">
      <h3 class="tactical-mono" style="margin:0;color:var(--color-foreground-heading)">SPECS REGISTRY CHECK</h3>
      <button class="tactical-drawer__close" onclick="toggleCompareModal(false)">×</button>
    </div>
    <div class="tactical-drawer__body" id="compare-drawer-body"></div>
    <div style="border-top:1px solid var(--color-border);padding-top:20px;text-align:center">
      <button class="button" onclick="launchDetailedComparison()" style="width:100%">RUN FULL REPORT</button>
    </div>`;
  document.body.appendChild(modal);
}

function toggleCompareModal(open) {
  const drawer = document.getElementById('tactical-compare-drawer');
  if (!drawer) return;
  if (open) { drawer.classList.add('open'); renderCompareItems(); }
  else drawer.classList.remove('open');
}
window.toggleCompareModal = toggleCompareModal;

function updateCompareUI() {
  const list = getCompareList();
  const trigger = document.getElementById('floating-compare-trigger');
  const countBadge = document.getElementById('compare-count-badge');
  if (trigger && countBadge) {
    trigger.style.display = list.length > 0 ? 'block' : 'none';
    countBadge.innerText = list.length;
  }
  document.querySelectorAll('.compare-toggle-btn').forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    if (list.some(item => item.handle === handle)) {
      btn.classList.add('in-compare');
      btn.innerHTML = 'REMOVE FROM COMPARE';
    } else {
      btn.classList.remove('in-compare');
      btn.innerHTML = 'ADD TO COMPARE';
    }
  });
  const detailedGrid = document.getElementById('tactical-detailed-comparison-grid');
  if (detailedGrid) renderDetailedComparisonTable(detailedGrid);
}

function renderCompareItems() {
  const list = getCompareList();
  const body = document.getElementById('compare-drawer-body');
  if (!body) return;
  if (list.length === 0) {
    body.innerHTML = `<p class="tactical-mono" style="text-align:center;color:var(--color-foreground-muted);padding:40px 0">NO ITEMS REGISTERED FOR SPECS CHECK.</p>`;
    return;
  }
  body.innerHTML = list.map(item => `
    <div style="display:flex;gap:15px;margin-bottom:20px;align-items:center;border-bottom:1px solid var(--color-border);padding-bottom:15px">
      <img src="${item.image}" alt="${item.title}" style="width:60px;height:60px;object-fit:cover;border:1px solid var(--color-border)" loading="lazy"/>
      <div style="flex:1">
        <h5 style="margin:0;font-size:0.85rem;color:var(--color-foreground-heading)">${item.title}</h5>
        <p class="tactical-mono" style="margin:5px 0 0;font-size:0.75rem;color:var(--color-accent-tactical)">${item.level}</p>
      </div>
      <button class="button" onclick="deleteFromCompare('${item.handle}')" style="background:transparent;border-color:red!important;color:red;padding:4px 10px;font-size:0.7rem">REMOVE</button>
    </div>`).join('');
}

function deleteFromCompare(handle) {
  let list = getCompareList().filter(item => item.handle !== handle);
  saveCompareList(list);
  updateCompareUI();
  renderCompareItems();
  showToast('REMOVED PRODUCT FROM SPEC COMPARISON.');
}
window.deleteFromCompare = deleteFromCompare;

function launchDetailedComparison() {
  toggleCompareModal(false);
  const comparisonSection = document.getElementById('tactical-comparison-section');
  if (comparisonSection) comparisonSection.scrollIntoView({ behavior: 'smooth' });
  else showToast('PROCESSING TECHNICAL REPORT DIRECTORY...');
}
window.launchDetailedComparison = launchDetailedComparison;

function renderDetailedComparisonTable(targetContainer) {
  const list = getCompareList();
  if (list.length === 0) {
    targetContainer.innerHTML = `
      <div style="text-align:center;padding:40px;border:1px dashed var(--color-border)">
        <p class="tactical-mono" style="color:var(--color-foreground-muted)">ADD TACTICAL PRODUCTS USING "ADD TO COMPARE" BUTTON TO GENERATE AN ENCRYPTED SPECIFICATION SHEET COMPARISON REPORT.</p>
      </div>`;
    return;
  }
  targetContainer.innerHTML = `
    <div class="comparison-container">
      <table class="comparison-table">
        <thead><tr>
          <th>TECHNICAL FIELD</th>
          ${list.map(item => `
            <th style="text-align:center">
              <img src="${item.image}" alt="${item.title}" style="width:80px;height:80px;object-fit:cover;margin-bottom:10px;border:1px solid var(--color-border)" loading="lazy"/><br>
              ${item.title.toUpperCase()}
            </th>`).join('')}
        </tr></thead>
        <tbody>
          <tr><td class="tactical-mono" style="font-weight:bold">THREAT RATING (NIJ)</td>${list.map(i => `<td style="text-align:center;color:var(--color-accent-tactical);font-weight:bold">${i.level}</td>`).join('')}</tr>
          <tr><td class="tactical-mono" style="font-weight:bold">WEIGHT (ESTIMATED)</td>${list.map(i => `<td style="text-align:center">${i.weight}</td>`).join('')}</tr>
          <tr><td class="tactical-mono" style="font-weight:bold">PROFILE THICKNESS</td>${list.map(i => `<td style="text-align:center">${i.thickness}</td>`).join('')}</tr>
          <tr><td class="tactical-mono" style="font-weight:bold">MATERIAL MATRIX</td>${list.map(i => `<td style="text-align:center">${i.material}</td>`).join('')}</tr>
          <tr><td class="tactical-mono" style="font-weight:bold">CLEARANCE ACTION</td>${list.map(i => `<td style="text-align:center"><button class="button" onclick="deleteFromCompare('${i.handle}')" style="background:transparent;border-color:red!important;color:red;padding:6px 12px;font-size:0.75rem">DELETE</button></td>`).join('')}</tr>
        </tbody>
      </table>
    </div>`;
}

/* ─── Toast System (DOM reuse, not recreate) ──────────────────── */
let _toast = null;
let _toastTimer = null;

function showToast(message) {
  if (!_toast) {
    _toast = document.createElement('div');
    _toast.id = 'tactical-toast';
    _toast.style.cssText = `
      position:fixed;bottom:30px;left:30px;
      background:#FFFFFF;border-left:3px solid var(--color-accent-tactical);
      border:1px solid var(--color-border);border-left:3px solid var(--color-accent-tactical);
      color:var(--color-foreground);padding:12px 24px;
      font-family:'Montserrat',sans-serif;font-size:0.8rem;z-index:2000;
      box-shadow:0 4px 20px rgba(5,11,24,0.12);
      transition:opacity 0.3s ease,transform 0.3s ease;opacity:0;transform:translateY(20px)`;
    document.body.appendChild(_toast);
  }
  _toast.innerText = `[SYSTEM] ${message}`;
  _toast.style.opacity = '1';
  _toast.style.transform = 'translateY(0)';
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => {
    _toast.style.opacity = '0';
    _toast.style.transform = 'translateY(20px)';
  }, 4000);
}

/* ─── Scroll Reveal Engine (GSAP + ScrollTrigger + Lenis) ─────── */
function initScrollReveal() {

  /* Reduced-motion: skip all JS animations, CSS fallback handles reveal */
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    forceFallbackReveal();
    return;
  }

  /* Mobile detection — lighter animation on phones */
  const isMobile = window.innerWidth < 768;

  try {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof Lenis === 'undefined') {
      throw new Error('Animation libraries not loaded yet');
    }

    gsap.registerPlugin(ScrollTrigger);

    /* ── Lenis smooth scroll (optimised config) ───────────────── */
    const lenis = new Lenis({
      lerp: isMobile ? 0.12 : 0.1,           // smoother lerp
      duration: isMobile ? 0.9 : 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      infinite: false,
      smoothTouch: false,                      // native scroll on mobile
      syncTouch: false
    });

    /* Single RAF loop — most efficient way to sync Lenis + GSAP */
    function raf(time) {
      lenis.raf(time);
      ScrollTrigger.update();
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    gsap.ticker.lagSmoothing(0);
    window.lenis = lenis;

    /* ── 1. Scroll Progress Bar ───────────────────────────────── */
    const progressBar = document.getElementById('scroll-progress-bar');
    if (progressBar) {
      gsap.to(progressBar, {
        width: '100%',
        ease: 'none',
        scrollTrigger: {
          trigger: document.body,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.3,
        }
      });
    }

    /* ── 2. Sticky header solid transition ────────────────────── */
    const header = document.querySelector('header-component');
    if (header) {
      ScrollTrigger.create({
        start: 'top -50px',
        end: 99999,
        onUpdate(self) {
          header.classList.toggle('header--sticky-solid', self.scroll() > 50);
        }
      });
    }

    /* ── Helper: animate with scroll trigger or immediately ───── */
    function revealEl(el, from, to, start = 'top 95%') {
      const rect = el.getBoundingClientRect();
      const aboveFold = rect.top < window.innerHeight * 1.15 || document.documentElement.scrollHeight <= window.innerHeight;
      if (aboveFold) {
        gsap.fromTo(el, from, to);
      } else {
        gsap.fromTo(el, from, { ...to, scrollTrigger: { trigger: el, start, toggleActions: 'play none none none' } });
      }
    }

    /* ── 3. Headings slide up (word-based, not char-split) ────── */
    const headings = document.querySelectorAll('.section-header, .h1, .h2, .h3, .h4, .h5, .h6');
    headings.forEach(el => revealEl(el,
      { opacity: 0, y: isMobile ? 20 : 35 },
      { opacity: 1, y: 0, duration: isMobile ? 0.6 : 0.9, ease: 'power3.out' }
    ));

    /* ── 4. Grid items — use GSAP batch (single IntersectionObserver for all) */
    const gridSelectors = '.grid, .product-grid, .novelties-grid, .categories-icons-row, .categories-banners-grid, .lookbook-grid, .blog-grid, .resource-list';
    document.querySelectorAll(gridSelectors).forEach(grid => {
      const children = Array.from(grid.children);
      if (!children.length) return;
      const rect = grid.getBoundingClientRect();
      const aboveFold = rect.top < window.innerHeight * 1.15 || document.documentElement.scrollHeight <= window.innerHeight;
      const vars = {
        opacity: 1, y: 0, scale: 1,
        duration: isMobile ? 0.5 : 0.7,
        stagger: isMobile ? 0.05 : 0.08,
        ease: 'power3.out'
      };
      if (aboveFold) {
        gsap.fromTo(children, { opacity: 0, y: 20, scale: 0.97 }, vars);
      } else {
        gsap.fromTo(children, { opacity: 0, y: 20, scale: 0.97 }, {
          ...vars,
          scrollTrigger: { trigger: grid, start: 'top 95%', toggleActions: 'play none none none' }
        });
      }
    });

    /* ── 5. General .reveal-element ──────────────────────────── */
    const gridSels = new Set(document.querySelectorAll(`${gridSelectors} > *`));
    document.querySelectorAll('.reveal-element').forEach(el => {
      if (gridSels.has(el)) return; // skip, already animated in batch
      revealEl(el,
        { opacity: 0, y: 20, scale: 0.97 },
        { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: 'power3.out' }
      );
    });

    /* ── 6. Lookbook slide-in columns ────────────────────────── */
    document.querySelectorAll('.lookbook-media-column').forEach(el => revealEl(el,
      { opacity: 0, x: -40 },
      { opacity: 1, x: 0, duration: 1.0, ease: 'power3.out' }
    ));
    document.querySelectorAll('.lookbook-details-column').forEach(el => revealEl(el,
      { opacity: 0, x: 40 },
      { opacity: 1, x: 0, duration: 1.0, ease: 'power3.out' }
    ));

    /* ── 7. Footer fades ─────────────────────────────────────── */
    document.querySelectorAll('.footer-newsletter-row, .footer-trust-row, .footer-menus-row, .footer-bottom').forEach(el =>
      revealEl(el, { opacity: 0 }, { opacity: 1, duration: 1.0, ease: 'power2.out' }, 'top 98%')
    );

    /* ── 8. Hero word reveal (optimised — word level, not char) ─ */
    initHeroWordReveal();

    /* ── 9. Stats counters ───────────────────────────────────── */
    initStatsCounters();

    /* ── 10. Testimonials — CSS marquee (zero JS CPU) ────────── */
    initCSSMarquee();

    /* ── 11. AJAX collection tabs ────────────────────────────── */
    initAJAXCollectionTabs();

    /* Refresh after images load */
    setTimeout(() => ScrollTrigger.refresh(), 200);
    window.addEventListener('load', () => ScrollTrigger.refresh());

  } catch (error) {
    console.warn('[KSA] Animation init failed, using fallback:', error);
    /* Retry after 800ms — scripts may still be loading (deferred) */
    setTimeout(() => {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof Lenis !== 'undefined') {
        initScrollReveal();
      } else {
        forceFallbackReveal();
      }
    }, 800);
  }
}

/* ─── Fallback: force visibility if animations fail ──────────── */
function forceFallbackReveal() {
  document.querySelectorAll([
    '.section-header', '.h1', '.h2', '.h3', '.h4', '.h5', '.h6',
    '.product-card', '.novelty-card', '.category-icon-card', '.testimonial',
    '.explore-banner-card', '.reveal-element', '.blog-card',
    '.lookbook-media-column', '.lookbook-details-column',
    '.footer-newsletter-row', '.footer-trust-row', '.footer-menus-row', '.footer-bottom'
  ].join(', ')).forEach(el => {
    el.style.opacity = '1';
    el.style.transform = 'none';
    el.style.visibility = 'visible';
  });
}

/* ─── Hero Word Reveal (replaces char-split — 95% fewer DOM nodes) */
function initHeroWordReveal() {
  const headings = document.querySelectorAll(
    '.hero__content-wrapper h2, .layered-slideshow__content h2, .layered-slideshow__content h1'
  );
  headings.forEach(heading => {
    if (heading.dataset.wordSplitDone) return;
    const text = heading.textContent.trim();
    if (!text) return;

    if (typeof gsap === 'undefined') {
      heading.style.opacity = '1';
      heading.style.visibility = 'visible';
      return;
    }
    heading.dataset.wordSplitDone = 'true';

    /* Split by word — massively fewer nodes than char split */
    heading.innerHTML = text.split(' ').map(word =>
      `<span style="display:inline-block;opacity:0;transform:translateY(20px);margin-right:0.28em">${word}</span>`
    ).join('');

    const spans = heading.querySelectorAll('span');
    const rect = heading.getBoundingClientRect();
    const isAboveFold = rect.top < window.innerHeight * 1.15 || document.documentElement.scrollHeight <= window.innerHeight;

    const animVars = {
      opacity: 1, y: 0,
      duration: 0.65,
      stagger: 0.06,
      ease: 'power3.out'
    };

    if (isAboveFold) {
      gsap.to(spans, animVars);
    } else {
      gsap.to(spans, {
        ...animVars,
        scrollTrigger: { trigger: heading, start: 'top 95%', toggleActions: 'play none none none' }
      });
    }
  });
}

/* ─── Animated Counters ───────────────────────────────────────── */
function initStatsCounters() {
  document.querySelectorAll('.stat-number').forEach(stat => {
    const originalText = stat.textContent.trim();
    if (!originalText) return;
    const matches = originalText.match(/([0-9.]+)(.*)/);
    if (!matches) return;
    const targetVal = parseFloat(matches[1]);
    const suffix = matches[2] || '';
    const decimals = matches[1].includes('.') ? matches[1].split('.')[1].length : 0;

    if (typeof gsap === 'undefined') {
      stat.textContent = originalText;
      return;
    }

    const counter = { value: 0 };
    const rect = stat.getBoundingClientRect();
    const isAboveFold = rect.top < window.innerHeight * 1.15 || document.documentElement.scrollHeight <= window.innerHeight;
    const animVars = {
      value: targetVal,
      duration: 1.8,
      ease: 'power2.out',
      onUpdate: () => { stat.textContent = counter.value.toFixed(decimals) + suffix; }
    };
    if (isAboveFold) {
      gsap.to(counter, animVars);
    } else {
      gsap.to(counter, {
        ...animVars,
        scrollTrigger: { trigger: stat, start: 'top 95%', toggleActions: 'play none none none' }
      });
    }
  });
}

/* ─── CSS Marquee (replaces JS GSAP marquee — zero CPU cost) ──── */
function initCSSMarquee() {
  const row = document.querySelector('.testimonials-slides-row');
  if (!row) return;
  const slides = Array.from(row.querySelectorAll('.testimonial-slide'));
  if (!slides.length) return;

  /* Style slides for the CSS marquee */
  slides.forEach(slide => slide.style.cssText = `
        position:relative;width:420px;flex-shrink:0;
        opacity:1;visibility:visible;transform:none;
        padding:30px 40px;margin-right:30px;
        border:1px solid var(--color-border);
        background:var(--color-background-card);
        box-shadow:0 4px 15px rgba(124, 26, 34, 0.05);
        display:flex;flex-direction:column;justify-content:center`);

  /* Hide JS-driven controls */
  document.querySelectorAll('.slider-dot, .slider-dots').forEach(el => el.style.display = 'none');

  /* Clone slides for seamless loop (CSS needs duplicate content) */
  slides.forEach(slide => row.appendChild(slide.cloneNode(true)));

  /* Add CSS class — animation defined in tactical-luxury.css */
  row.classList.add('css-marquee');
}

/* ─── AJAX Collection Tabs ────────────────────────────────────── */
function initAJAXCollectionTabs() {
  document.querySelectorAll('.novelties-filter-bar').forEach(bar => {
    const tabs = bar.querySelectorAll('.filter-tab');
    const grid = bar.parentElement.querySelector('.novelties-grid');
    if (!grid) return;

    tabs.forEach(tab => {
      const newTab = tab.cloneNode(true);
      tab.parentNode.replaceChild(newTab, tab);
      newTab.addEventListener('click', (e) => {
        e.preventDefault();
        bar.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active', 'is-active'));
        newTab.classList.add('active', 'is-active');

        const filter = newTab.getAttribute('data-filter');
        const cards = grid.querySelectorAll('.novelty-card');

        /* Lightweight loader */
        let loader = grid.querySelector('.grid-loader-overlay');
        if (!loader) {
          loader = document.createElement('div');
          loader.className = 'grid-loader-overlay';
          loader.innerHTML = `<div style="width:36px;height:36px;border:3px solid rgba(124, 26, 34, 0.15);border-top-color:var(--color-accent-tactical);border-radius:50%;animation:gridSpin 0.8s linear infinite"></div><style>@keyframes gridSpin{to{transform:rotate(360deg)}}</style>`;
          loader.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(250, 248, 245, 0.8);backdrop-filter:blur(4px);z-index:20;opacity:0;pointer-events:none;transition:opacity 0.25s ease';
          grid.style.position = 'relative';
          grid.appendChild(loader);
        }

        loader.style.opacity = '1';
        loader.style.pointerEvents = 'auto';

        if (typeof gsap !== 'undefined') {
          gsap.to(cards, {
            opacity: 0, scale: 0.93, y: 15,
            duration: 0.3, stagger: 0.02, ease: 'power2.in',
            onComplete() {
              setTimeout(() => {
                loader.style.opacity = '0';
                loader.style.pointerEvents = 'none';
                cards.forEach(card => {
                  let show = false;
                  if (filter === 'all') show = true;
                  else if (filter === 'armour'      && card.getAttribute('data-armour')      === 'true') show = true;
                  else if (filter === 'clothing'    && card.getAttribute('data-clothing')    === 'true') show = true;
                  else if (filter === 'accessories' && card.getAttribute('data-accessories') === 'true') show = true;
                  card.style.display = show ? 'flex' : 'none';
                });
                const visible = Array.from(cards).filter(c => c.style.display !== 'none');
                gsap.fromTo(visible,
                  { opacity: 0, scale: 0.93, y: 15 },
                  { opacity: 1, scale: 1, y: 0, duration: 0.55, stagger: 0.04, ease: 'power3.out' }
                );
              }, 300);
            }
          });
        } else {
          loader.style.opacity = '0';
          loader.style.pointerEvents = 'none';
          cards.forEach(card => {
            let show = false;
            if (filter === 'all') show = true;
            else if (filter === 'armour'      && card.getAttribute('data-armour')      === 'true') show = true;
            else if (filter === 'clothing'    && card.getAttribute('data-clothing')    === 'true') show = true;
            else if (filter === 'accessories' && card.getAttribute('data-accessories') === 'true') show = true;
            card.style.display = show ? 'flex' : 'none';
            card.style.opacity = '1';
            card.style.transform = 'none';
          });
        }
      });
    });
  });
}
